import React from 'react';
import 'css/InfoMessage/InfoMessage.scss';
import infoIcon from 'images/icons/big9/exclamation_mark.svg';
import infoIconBlue from 'images/icons/info_circle.svg';

const InfoMessage = ({ text, blue = false, aligned = 'center' }) => {
    return (
        <section
            className={`info-message ${blue && 'blue'} ${aligned === 'left' &&
                'left'}`}
        >
            <img src={blue ? infoIconBlue : infoIcon} alt="icon" />
            {text}
        </section>
    );
};

export default InfoMessage;
